export const wbuButtonHook = 'wbu-button';
